/**
 * Validátor pro kontrolu telefoního čísla podle reguláru
 * @param el
 * @param arg
 * @param val
 * @returns {boolean}
 * @constructor
 */
Nette.validators.SlimShopCoreUtilsValidatorsSlimValidators_phoneNumber = (el, arg, val) => {

    const
        pattern = arg[1][arg[0]],
        regExp = new RegExp(pattern, 'ui');

    return regExp.test(val);
}
